class BundleSelector extends HTMLElement {
  constructor() {
    super();
    
    this.quantityInputs = this.querySelectorAll('.bundle-item__quantity-value');
    this.minusButtons = this.querySelectorAll('.bundle-item__quantity-btn--minus');
    this.plusButtons = this.querySelectorAll('.bundle-item__quantity-btn--plus');
    
    this.init();
  }

  init() {
    this.minusButtons.forEach(btn => {
      btn.addEventListener('click', this.decreaseQuantity.bind(this));
    });

    this.plusButtons.forEach(btn => {
      btn.addEventListener('click', this.increaseQuantity.bind(this));
    });

    this.quantityInputs.forEach(input => {
      input.addEventListener('change', this.validateQuantity.bind(this));
    });
  }

  decreaseQuantity(event) {
    const button = event.currentTarget;
    const input = button.parentElement.querySelector('.bundle-item__quantity-value');
    const currentValue = parseInt(input.value);
    const minValue = parseInt(input.min) || 0;

    if (currentValue > minValue) {
      input.value = currentValue - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  increaseQuantity(event) {
    const button = event.currentTarget;
    const input = button.parentElement.querySelector('.bundle-item__quantity-value');
    const currentValue = parseInt(input.value);
    const maxValue = parseInt(input.max) || Infinity;

    if (currentValue < maxValue) {
      input.value = currentValue + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  validateQuantity(event) {
    const input = event.target;
    const value = parseInt(input.value);
    const min = parseInt(input.min) || 0;
    const max = parseInt(input.max) || Infinity;

    if (isNaN(value) || value < min) {
      input.value = min;
    } else if (value > max) {
      input.value = max;
    }
  }
}

customElements.define('bundle-selector', BundleSelector);